function add0(m) {
  return m < 10 ? '0' + m : m
}

function format(shijianchuo) {
  //shijianchuo是整数，否则要parseInt转换
  var time = new Date(shijianchuo * 1000);
  var y = time.getFullYear();
  var m = time.getMonth() + 1;
  var d = time.getDate();
  var h = time.getHours();
  var mm = time.getMinutes();
  var s = time.getSeconds();
  return y + '-' + add0(m) + '-' + add0(d) + ' ' + add0(h) + ':' + add0(mm) + ':' + add0(s);
}


function getdate(times) {  //将时间戳（秒） 转成时间格式
  var now = new Date(times * 1000),
    y = now.getFullYear(),
    m = now.getMonth() + 1,
    d = now.getDate();
  var h = now.getHours();
  var mm = now.getMinutes();
  var s = now.getSeconds();
  return y + '-' + add0(m) + '-' + add0(d) + ' ' + add0(h) + ':' + add0(mm) + ':' + add0(s);
}

function dateformat(micro_second) {
  // 总秒数
  var second = Math.floor(micro_second / 1000);
  // 天数
  var day = Math.floor(second / 3600 / 24);
  // 小时
  var hour = Math.floor(second / 3600 % 24);
  // 分钟
  var min = Math.floor(second / 60 % 60);
  // 秒
  var sec = Math.floor(second % 60);
//   return day + "天" + hr + "小时" + min + "分钟" + sec + "秒";
  return {day : add0(day) ,hour: add0(hour) , min: add0(min), sec: add0(sec)} 
}

function dateformat2(micro_second) {
    // 总秒数
    var second = Math.floor(micro_second / 1000);
    // 天数
    var day = Math.floor(second / 3600 / 24);
    // 小时
    var hour = Math.floor(second / 3600 % 24);
    // 分钟
    var min = Math.floor(second / 60 % 60);
    // 秒
    var sec = Math.floor(second % 60);
    return add0(day) + ":" + add0(hour) + ":" + add0(min) + ":" + add0(sec) ;
  }



  function jstime(str_time){   //将日期格式转成时间戳
    let  date = new Date(str_time);
    // 有三种方式获取
    return date.getTime()/1000;
} 

function getOldMonth() {//月份整理
  var arr = [];
  var theMonths = ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"];
  // var theMonths = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"];
  var nowDate = new Date();
  for (var i = 11; i >= 0; i--) {
      var oldDate = new Date(nowDate.getFullYear(), nowDate.getMonth() - i-1, 1);
      var year = oldDate.getFullYear();
      var month = theMonths[oldDate.getMonth()];
      arr.push(year + "-" + month);
  }
  return arr;
}
export default {
  add0,
  format,
  getdate,
  dateformat,
  dateformat2,
  jstime,
  getOldMonth
}
